// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"ManageDataflow_checkboxWrapper__2D5yL","cancelButton":"ManageDataflow_cancelButton__33-Ct"};